import React, { useEffect, useState } from 'react';
import { back, chevron_right, expand, gear } from '../../Images/Icons';
import { useNavigate, useParams } from 'react-router-dom';
import { View } from '../../Components';
import getDataPrice  from '../../Services/GlobalServies';
import { set } from 'date-fns';
import { GetElecticPrice } from '../../Services/StatisticServices';

const ElectricityPricePage = () => {
    const navigation = useNavigate();
    const access_token = localStorage.getItem("access_token");
    const station_get = localStorage.getItem("station_get");

    // alert(atob(station_get))
    const [state, setAllState] = useState({});
    const [price, setPrice] = useState(0);

    const setState = data => {
        setAllState(prevState => ({ ...prevState, ...data }));
    }

    const onGoback = () => {
        navigation(-1);
    }


    const onEdit = () => {
        navigation('/home/statistic/electricityprice/edit/');
    }

    
    function getDataPrice(data) {
        GetElecticPrice(data).then((result) => {
            setPrice(result.data.electricity_price)
        }).catch(({ response }) => {
           console.log('Error : ',response)
        });
    }
    
    
    useEffect(() => {  
        getDataPrice(atob(station_get))   
    },[])
    return (
        <div>
            <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', }}>
                <div style={{ display: 'flex', margin: '0 20px' }}>
                    <div onClick={onGoback} style={{
                        display: 'flex', justifyContent: 'center', cursor: 'pointer',
                        alignItems: 'center', width: 32, height: 32, background: 'white', borderRadius: 16
                    }}>
                        <img src={back} alt="" style={{ width: 28, height: 28 }} />
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'white', marginLeft: 12 }}>Electricity Price</div>
                </div>
            </div>
            <div className="page-content" style={{ background: '#F2F5FA', padding: 16 }}>
                <div style={{ height: 165, background: 'white', borderRadius: 8, padding: 12 }}>
                    <div style={{ fontSize: 18, fontWeight: 500, color: 'black', marginTop: 10 }}>
                        Current Electricity Price 
                    </div>
                    <div style={{ height: 54, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#515151' }}>Electricity Price</div>
                        <div style={{ fontSize: 18, fontWeight: 500, color: '#292929' }}>{price} IDR/kWh</div>
                    </div>
                    <div onClick={onEdit} style={{
                        width: '100%', height: 48, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#EEFFF9',
                        color: '#006B34', fontSize: 16, fontWeight: 500, cursor: 'pointer'
                    }}>
                        Edit
                    </div>
                </div> 
            </div>
        </div>

    )
}

export default ElectricityPricePage